import React from "react";
import { Link } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import { AddCommentOutlined } from "@mui/icons-material";

import SearchBar from "./SearchBar";
import QuickActions from "./QuickActions";


const CRMAppBar = () => {
  return (
    <div className="flex flex-grow items-center justify-center gap-2">
      <QuickActions />

      <SearchBar />


      <Tooltip title="New Feedback" arrow>
        <Link to="/app/crm/feedback/create">
          <IconButton>
            <AddCommentOutlined color="primary" />
          </IconButton>
        </Link>
      </Tooltip>
      
    </div>
  );
};

export default CRMAppBar;
